export class AttachmentsObj {
    attachment: File;
    attachment_name: string;
}
